import { MsClose as C } from "@sunrise/icons";
import { pageUtils as u, clickAnywhereHandler as f } from "@sunrise/shared";
import { defineComponent as h, getCurrentInstance as k, ref as v, onMounted as w, watch as B } from "vue";
import S from "./index527.js";
import F from "./index25.js";
import x from "./index37.js";
const A = h({
  name: "CsModal",
  components: {
    MsClose: C,
    CsPrimaryButton: x,
    CsGhostButton: F
  },
  props: {
    visible: { type: Boolean, default: !1 },
    headerText: { type: String, default: "Filter" },
    contentRendered: { type: Boolean, default: !1 },
    channel: String,
    isFullscreen: Boolean,
    primaryLabel: String,
    secondaryLabel: String,
    isLoading: Boolean
  },
  emits: ["update:visible", "click:primary", "click:secondary"],
  setup(n, { emit: t }) {
    var s;
    const r = (s = k()) == null ? void 0 : s.proxy, o = v(null), l = S();
    let e;
    w(() => {
      n.visible && i();
    }), B(
      () => n.visible,
      (a) => a ? i() : y()
    );
    function d() {
      t("click:primary");
    }
    function m() {
      t("click:secondary");
    }
    function p(a) {
      l.at(a);
    }
    function b() {
      l.prev();
    }
    const g = () => {
      switch (n.channel) {
        case "auto":
          return "bg-color-signatur-auto-100";
        case "local-information":
          return "bg-color-brand-yellow-50";
        case "real-estate":
          return "bg-color-signatur-immo-100";
        default:
          return "bg-color-neutral-white";
      }
    };
    async function i() {
      u.disablePageScroll(), await (r == null ? void 0 : r.$nextTick()), o.value && (p(o.value), e || (e = f.subscribe(o.value, c)));
    }
    function y() {
      u.enablePageScroll(), b(), e && (f.unsubscribe(e), e = null);
    }
    function c() {
      t("update:visible", !1);
    }
    return {
      closeModal: c,
      dialogRef: o,
      getBackgroundColor: g,
      onPrimaryClick: d,
      onSecondaryClick: m
    };
  }
});
export {
  A as default
};
